/**
 * CacheProviderService.js - sessionStorage only (aligned with admin4.0).
 * Use setCachevalue(value, key), getCachevalue(key), clearCachevalue(key), clearAllCachevalue().
 */
const setCachevalue = (value, key) => {
  sessionStorage.setItem(key, value !== undefined && value !== null ? String(value) : "");
};

const getCachevalue = (key) => {
  return sessionStorage.getItem(key);
};

const clearCachevalue = (key) => {
  sessionStorage.removeItem(key);
};

const clearAllCachevalue = () => {
  sessionStorage.clear();
};

export { setCachevalue, getCachevalue, clearCachevalue, clearAllCachevalue };
